export default __webpack_public_path__ + "static/media/graphsPreviewDark@2x.2109589e.png";